/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import MaskedInput from "react-text-mask";
import { StateSelection, Loader } from "@components/common";
import { ContactService } from "@services";
import utils from "@utils";
import { Modal, ConfirmationModal } from "../../../../../components";

const AddClientContactModal = ({
	show,
	onCancel,
	onSave,
	user,
	clientId,
	organizationId,
}) => {
	const { lang } = global;

	const [errors, setErrors] = useState({
		firstNameError: false,
		lastNameError: false,
		emailError: false,
		phoneError: false,
	});

	const phoneMask = ['(', /[0-9]/, /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [emailAddress, setEmailAddress] = useState('');
	const [mobilePhone, setMobilePhone] = useState('');
	const [streetAddress1, setStreetAddress1] = useState('');
	const [city, setCity] = useState('');
	const [stateId, setStateId] = useState('');
	const [zipcode, setZipcode] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const confirmationModal = useRef();

	const validateForm = () => {
		let isValid = false;

		errors.firstNameError = firstName === "";
		errors.lastNameError = lastName === "";
		errors.phoneError = mobilePhone === "";
		errors.emailError = !/^\S+@\S+\.\S{2,}$/.test(emailAddress);

		setErrors({ ...errors });

		isValid = Object.values(errors).filter(error => error === true).length === 0;

		return isValid;
	};

	const performMergeContact = ({ Id: contactId }) => {
		const params = {
			Id: contactId,
			clientId,
		};

		ContactService.mergeContact(params)
			.then(response => {
				utils.notify({
					type: "success",
					message: lang.t("Contact successfully merged"),
					timeOut: 1500,
				});

				onCancel();
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Unable to merge contact"),
					timeOut: 1500,
				});
			});
	};

	const saveContact = () => {
		const isValid = validateForm();

		if (isValid) {
			const params = {
				firstName,
				lastName,
				emailAddress,
				streetAddress1,
				mobilePhone,
				city,
				stateId,
				zipcode,
				clientId,
				organizationId,
			};

			ContactService.save(params)
				.then(response => {
					utils.notify({
						type: "success",
						message: lang.t("Contact successfully created"),
						timeOut: 1500,
					});

					setIsLoading(false);
					onSave();
				})
				.catch(error => {
					const {
						response: { data, status },
					} = error;

					if (status === 409 && data && data.Data) {
						confirmationModal.current.openModal({
							title: "Merge Contact",
							message: data.Message,
							confirmButton: "Yes",
							onConfirm: () => performMergeContact(data.Data),
							onCancel: () => setIsLoading(false),
						});
						return;
					}

					setIsLoading(false);

					if (params.clientId || params.organizationId) {
						utils.notify({
							type: "error",
							message:
								(data && lang.t("A contact with this email already exists")) ||
								lang.t("Error creating contact"),
							timeOut: 1500,
						});
					} else {
						utils.notify({
							type: "error",
							message: lang.t("A client must be selected before creating a contact"),
							timeOut: 1500,
						});
					}

					onCancel();
				});
		}
	};

	return (
		<Modal
			show={show}
			onHide={onCancel}
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Add Client Contact")}</Modal.Title>
			</Modal.Header>
			<Modal.Body id="add-client-modal" />
			<div className="form-horizontal">
				<div className="row form-group">
					<label
						htmlFor="firstName"
						className="col-sm-4 control-label"
					>
						{lang.t("First Name")}:
					</label>
					<div className="col-sm-6">
						<input
							name="FirstName"
							type="text"
							className={classNames("form-control", {
								error: errors.firstNameError,
							})}
							value={firstName}
							onChange={event => setFirstName(event.target.value)}
						/>
					</div>
				</div>

				<div className="row form-group">
					<label
						htmlFor="lastName"
						className="col-sm-4 control-label"
					>
						{lang.t("Last Name")}:
					</label>
					<div className="col-sm-6">
						<input
							name="LastName"
							type="text"
							className={classNames("form-control", {
								error: errors.lastNameError,
							})}
							value={lastName}
							onChange={event => setLastName(event.target.value)}
						/>
					</div>
				</div>

				<div className="row form-group">
					<label
						htmlFor="emailAddress"
						className="col-sm-4 control-label"
					>
						{lang.t("Email Address")}:
					</label>
					<div className="col-sm-6">
						<input
							name="EmailAddress"
							type="text"
							className={classNames("form-control", {
								error: errors.emailError,
							})}
							value={emailAddress}
							onChange={event => setEmailAddress(event.target.value)}
						/>
					</div>
				</div>

				<div className="row form-group">
					<label
						htmlFor="phoneNumber"
						className="col-sm-4 control-label"
					>
						{lang.t("Phone Number")}:
					</label>
					<div className="col-sm-6">
						<MaskedInput
							name="MobilePhone"
							type="tel"
							mask={phoneMask}
							className={classNames("form-control", {
								error: errors.phoneError,
							})}
							value={mobilePhone}
							onChange={event => setMobilePhone(event.target.value)}
						/>
					</div>
				</div>

				<div className="row form-group">
					<label
						htmlFor=" streetAddress"
						className="col-sm-4 control-label"
					>
						{lang.t("Street Address")}:
					</label>
					<div className="col-sm-6">
						<input
							name="StreetAddress1"
							type="text"
							className="form-control"
							value={streetAddress1}
							onChange={event => setStreetAddress1(event.target.value)}
						/>
					</div>
				</div>

				<div className="row form-group">
					<label
						htmlFor="city"
						className="col-sm-4 control-label"
					>
						{lang.t("City")}:
					</label>
					<div className="col-sm-6">
						<input
							name="City"
							type="text"
							className="form-control"
							value={city}
							onChange={event => setCity(event.target.value)}
						/>
					</div>
				</div>

				<div className="row form-group">
					<label
						htmlFor="state"
						className="col-sm-4 control-label"
					>
						{lang.t("State")}:
					</label>
					<div className="col-sm-6">
						<StateSelection
							name="StateId"
							value={stateId}
							onChange={event => setStateId(event.target.value)}
						/>
					</div>
				</div>

				<div className="row form-group">
					<label
						htmlFor="zipCode"
						className="col-sm-4 control-label"
					>
						{lang.t("Zip Code")}:
					</label>
					<div className="col-sm-6">
						<input
							name="Zipcode"
							type="tel"
							className="form-control"
							maxLength={5}
							value={zipcode}
							onChange={event => setZipcode(event.target.value)}
						/>
					</div>
				</div>
				<Loader active={isLoading} />
			</div>

			<Modal.Footer>
				<button
					type="button"
					className="btn btn-default"
					onClick={onCancel}
				>
					{lang.t("Cancel")}
				</button>

				<button
					type="button"
					className="btn btn-primary"
					onClick={saveContact}
				>
					{lang.t("Save")}
				</button>
			</Modal.Footer>
			<ConfirmationModal ref={confirmationModal} />
		</Modal>
	);
};

AddClientContactModal.propTypes = {
	show           : PropTypes.bool,
	onCancel       : PropTypes.func,
	user           : PropTypes.object,
	clientId       : PropTypes.number,
	organizationId : PropTypes.number,
};

AddClientContactModal.defaultProps = {
	show     : false,
	onCancel : () => { },
};

export default AddClientContactModal;
